/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


	$(".team-button").each(function(){

		$(this).on('click', function(){
			if($(this).prev().hasClass('open')){
				$(this).prev().removeClass('open')
				$(this).children().first().html('Read More')
				$(this).children().last().removeClass('open')
			} else{
				$(this).prev().addClass('open')
				$(this).children().first().html('Read Less')
				$(this).children().last().addClass('open')
			}
			
		})
	  });


	  let headerBtn = $('.header__btn');
	  let headerLinks = $('.header__links');
	  let header = $('.header');
	  headerBtn.click(function (e) {
		  e.preventDefault();
		  headerLinks.toggleClass('open');
		  headerBtn.toggleClass('open');
		  header.toggleClass('open');

	  });


	//   let headerLinksOpen = $('#menu-main');
	//   headerLinksOpen.on('click',function () {
	// 	headerLinks.toggleClass('open');
	// 	  headerBtn.toggleClass('open');
	// 	  header.toggleClass('open');			
	// });


	$(window).scroll(function() {

		var sticky = $('header'),
		scroll = $(window).scrollTop();

		if (scroll >= 200) $('header .container').addClass('fixed');
		else $('header .container').removeClass('fixed');

		var backToTop = $('.back-to-top')
		if (scroll >= 200) backToTop.addClass('open');
		else backToTop.removeClass('open');

		var windowBottom = $(this).scrollTop() + $(this).innerHeight();
		
		
		$(".fade").each(function() {
		  /* Check the location of each desired element */
		  var objectBottom = $(this).offset().top + $(this).outerHeight();
		  
		  /* If the element is completely within bounds of the window, fade it in */
		  if ((objectBottom-400) < windowBottom) { 
			if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
		  }
		});


		$(".fade-last").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom-200) < windowBottom) { 
			  if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
			}
		});

		$(".fade-test").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom-700) < windowBottom) { 
			  if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
			}
		});


		$(".anim-line").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom+ 300) < windowBottom) { 
			  $(this).addClass('open')
			}
		});
		$(".anim-line-about1").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom+ 300) < windowBottom) { 
			  $(this).addClass('open')
			}
		});
		$(".anim-line-about2").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom+ 100) < windowBottom) { 
			  $(this).addClass('open')
			}
		});
		$(".anim-line-about3").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom+ 100) < windowBottom) { 
			  $(this).addClass('open')
			}
		});
		$(".anim-line-about4").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom+ 100) < windowBottom) { 
			  $(this).addClass('open')
			}
		});
		$(".anim-line-about5").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom+ 100) < windowBottom) { 
			  $(this).addClass('open')
			}
		});


		$(".portfolio-wrap").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom) < windowBottom) { 
			  $(this).addClass('open')
			}
		});

		$(".portfolio-heading").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom) < windowBottom) { 
			  $(this).addClass('open')
			}
		});

		$(".portfolio-button").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom) < windowBottom) { 
			  $(this).addClass('open')
			}
		});

	  }).scroll();

	  $(".anim-line-front1").addClass('open');
	  $(".anim-line-front2").addClass('open');
	  $(".anim-line-front3").addClass('open');

	  $(".anim-line-contact1").addClass('open');
	  $(".anim-line-team1").addClass('open');
	  $(".anim-line-team2").addClass('open');
	  $(".anim-line-team3").addClass('open');

	  $(".anim-line-case1").addClass('open');
	  $(".anim-line-case2").addClass('open');
	 $(".anim-line-case3").addClass('open');
	 
	 $(".anim-line-portfolio1").addClass('open');

	  $('.portfolio-button-wrap').click(function (e) {
		e.preventDefault();
		$(this).prev().toggleClass('open');
		if($(this).prev().hasClass('open')){
			$(this).children(":first").html('READ LESS -');
		} else {
			$(this).children(":first").html('READ MORE +');
		}
		
	});


	$('.portfolio-description').each(function() {
		if($(this).html().length == 29){
			$(this).next().remove()
		} 
	});
}); 



